export const DEBUG = false;
const URL = 'https://sentry.hubteam.com/sentry/dashboardui/?query=';
const createSentryLink = id => `${URL}is%3Aunresolved+report-management%3A${id}`;
export const debugSentryCapture = eventId => {
  // eslint-disable-next-line no-console
  console.log(`Sentry: logging to ${createSentryLink(eventId)}`);
};